import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseBoardComponent } from '../actionviews/baseBoard';
import { BoardData } from '../models/boardData';

/**
 * this class can be used to gain information about the currently active board
 */
@Injectable()
export class ActiveBoardService {

  constructor() { }

  private activeBoard: BaseBoardComponent;

  public setActiveBoard(activeBoard: BaseBoardComponent) {
    this.activeBoard = activeBoard;
  }

  getBoardData(): Observable<BoardData> {
    return this.activeBoard.getBoardData();
  }
}
